export default {"src":"/_next/static/media/meet-logo.fa223ab6.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};